import React, { useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { GetSasConsicaoPagamentoOptions, ISasPropostaOrdemCompra, updatePropostaComercial } from '@app/api/sas/sasProposta';
import { Button, FormDatePicker, FormSelect, FormSubmitButton, MasterDetailForm, Row } from '@digital/ui';
import { UploadMultipleTableTmp, Visibility } from '@app/components';
import { useRecoilState, useRecoilValue } from 'recoil';
import { editandoState, modalAcoesIdState, ordemCompraRodadaNegociacaoIdState, reloadVendorListState, dadosGeraisState } from '../../atoms';
import * as Yup from 'yup';
import { thousandSeparator, toUpperCaseFirstChar } from '@app/helpers/stringHelper';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import { getArquivosDocumentoOrdemCompraByOc } from '@app/api/sas/sasDocumentoOrdemCompra';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';
import optionsMoedas from '@app/helpers/optionsMoedas';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

interface Props {
    sasPropostaId: string;
    sasProposta: ISasPropostaOrdemCompra;
}

const ModalConfirmarPropostaComercial = (props: Props) => {
    const { sasPropostaId, sasProposta } = props;
    const [exibirModal, setExibirModal] = useState(false);
    const [editando, setEditando] = useRecoilState(editandoState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const ehAditivo = dadosGerais.tipoContrato && dadosGerais.tipo === ETipoDemanda.Aditivo;

    const handleCancel = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSubmit = (values: any) => {
        const form = new FormData();
        form.append('sasPropostaId', sasPropostaId);
        form.append('status', 'Recebida');
        form.append('dataRecebimentoPropostaComercial', values.dataRecebimentoPropostaComercial);
        let vpc = !values.valorPropostaComercial || values.valorPropostaComercial && values.valorPropostaComercial == 0
            ? '0'
            : thousandSeparator(values.valorPropostaComercial);
        form.append('valorPropostaComercial', vpc);
        form.append('moeda', '0');
        form.append('sasCondicaoPagamentoId', values.sasCondicaoPagamentoId);
        form.append('isPropostaInicialEqualizada', values.isPropostaInicialEqualizada);
        values.anexosPropostaComercial.map((c: any) => {
            form.append("anexosPropostaComercial", c);
        });

        if (editando.sasPropostaId == sasProposta.id) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }}
                />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise((resolve, reject) => {
                        updatePropostaComercial(form).then((data: any) => {
                            if (data && data.valid) {
                                setReloadVendorList(!reloadVendorList);
                                handleCancel();
                                return resolve(true);
                            } else {
                                if (data.notifications && data.notifications.length > 0) {
                                    const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                        return c.property == 'justificativaEdicao';
                                    });
                                    if (erroJustificativaEdicao >= 0) {
                                        return reject(false);
                                    }
                                }

                                if (data.days) {
                                    Modal.confirm({
                                        title: 'Data fora do prazo',
                                        content: `A data de recebimento informada está fora do prazo definido. Está ${data.days < 0 ? `${data.days * -1} dia(s) adiantado(s)` : `${data.days} dia(s) atrasado(s)`} . Confirma que esta data está correta?`,
                                        cancelText: 'Não',
                                        onCancel: () => { 
                                            return reject(false);
                                        },
                                        okText: 'Sim',
                                        onOk: () => {
                                            form.append('ignoraData', 'true');
                                            updatePropostaComercial(form)
                                                .then((data: any) => {
                                                    if (data && data.valid) {
                                                        setReloadVendorList(!reloadVendorList);
                                                        handleCancel();
                                                        resolve(true);
                                                    }
                                                });
                                        },
                                    });
                                }
                            }
                        });
                    });
                },
                onCancel: () => { },
            });
        } else {
            updatePropostaComercial(form).then((data: any) => {
                if (data && data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    handleCancel();
                } else {
                    if (data.days) {
                        Modal.confirm({
                            title: 'Data fora do prazo',
                            content: `A data de recebimento informada está fora do prazo definido. Está ${data.days < 0 ? `${data.days * -1} dia(s) adiantado(s)` : `${data.days} dia(s) atrasado(s)`} . Confirma que esta data está correta?`,
                            cancelText: 'Não',
                            onCancel: () => {

                            },
                            okText: 'Sim',
                            onOk: () => {
                                form.append('ignoraData', 'true');
                                updatePropostaComercial(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            setReloadVendorList(!reloadVendorList);
                                            handleCancel();
                                        }
                                    });
                            },
                        });
                    }
                }
            });
        }
    };

    return (
        <Visibility visible={true}>
            <Tooltip title={"Proposta Comercial " + toUpperCaseFirstChar(sasProposta.statusPropostaComercial || "")}>
                <Button icon='business-new_company' onClick={() => { setExibirModal(true); }} />
            </Tooltip>
            <Visibility visible={exibirModal} >

                <Modal
                    title="Proposta Comercial"
                    width="980px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key={`formPropostaComercial_${sasPropostaId}`}
                        initialValues={sasProposta}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <Visibility visible={
                                editando.sasPropostaId === sasProposta.id ||
                                sasProposta.statusPropostaComercial !== 'Recebida'
                            }>
                                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                            </Visibility>
                        ]}
                        validationSchema={Yup.object().shape({
                            dataRecebimentoPropostaComercial: Yup.string().required('O campo Data de recebimento da proposta é obrigatório.'),
                            valorPropostaComercial: Yup.number()
                                .typeError('O campo Valor da Proposta Comercial é inválido.')
                                .min(ehAditivo ? 0 : 0.01, 'O campo Valor da Proposta Comercial é obrigatório.')
                                .required('O campo Valor da Proposta Comercial é obrigatório.'),
                            sasCondicaoPagamentoId: Yup.string().required('O campo Condição de Pagamento é obrigatório.'),
                            anexosPropostaComercial: Yup.array().required('É necessário anexar no mínimo um arquivo.')
                        })}
                    >
                        <Row>
                            <FormDatePicker
                                label='Data de recebimento da proposta'
                                name='dataRecebimentoPropostaComercial'
                                format='DD/MM/YYYY'
                                span={5}
                                disabled={editando.sasPropostaId !== sasPropostaId && sasProposta.statusPropostaComercial === 'Recebida'}
                            />
                            <CurrencyInput3 label='Valor da Proposta Comercial ($)' name="valorPropostaComercial" span={7} disabled={editando.sasPropostaId !== sasPropostaId && sasProposta.statusPropostaComercial === 'Recebida'} />

                            {/* <FormSelect options={optionsMoedas} name="moeda" label="Moeda" span={2} disabled={editando.sasPropostaId !== sasPropostaId && sasProposta.statusPropostaComercial === 'Recebida'} /> */}
                        </Row>
                        <Row>
                            <FormSelect
                                label='Condição de Pagamento'
                                name="sasCondicaoPagamentoId"
                                getOptions={GetSasConsicaoPagamentoOptions}
                                span={ehAditivo ? 12 : 9}
                                disabled={editando.sasPropostaId !== sasPropostaId && sasProposta.statusPropostaComercial === 'Recebida'}
                            />
                            {
                                !ehAditivo &&
                                <FormSelect
                                    label='Proposta Equalizada?'
                                    name="isPropostaInicialEqualizada"
                                    options={
                                        [,
                                            { text: 'Não foi possível Equalizar', value: 2 },
                                            { text: 'Sim', value: 1 },
                                            { text: 'Não', value: 0 }
                                        ]
                                    }
                                    span={3}
                                    disabled={editando.sasPropostaId !== sasPropostaId && sasProposta.statusPropostaComercial === 'Recebida'}
                                />
                            }
                        </Row>
                        <Row>
                            <UploadMultipleTableTmp
                                name='anexosPropostaComercial'
                                idDoComponente={`formPropostaComercialUpload_${sasPropostaId}`}
                                type='primary'
                                tablePagination={true}
                                onGetArquivos={async () => {
                                    return await getArquivosDocumentoOrdemCompraByOc({
                                        ordemCompraId: sasProposta.ordemCompraId,
                                        sasTipoDocumentoId: EGuidTipoSasDocumento.AceitePropostaComercial,
                                        sasPropostaId: sasProposta.id,
                                        ordemCompraRodadaNegociacaoId: ordemCompraRodadaNegociacaoId
                                    }).then((data: any) => {
                                        return data || [];
                                    });
                                }}
                            />
                        </Row>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
    );
};

export default ModalConfirmarPropostaComercial;